import axios from 'axios';
import { getI18n } from 'react-i18next';
import { showInfoNotification, showErrorNotification } from './notifications';
import Constants from '../utils/Constants';
import _ from 'lodash';
import { createErrorMessage } from '../components/errors/Errors';

const onSuccess = (dispatch) => () => {
    dispatch(showInfoNotification(getI18n().t('request-password-reset.notification.request-received')));
};

const onError = (dispatch) => (error) => {
    const { response } = error;
    if (response && response.data && _.isArray(response.data)) {
        response.data.forEach((errObject) => {
            const message = createErrorMessage(errObject.code, errObject.params);
            dispatch(showErrorNotification(message));
        });
    } else {
        dispatch(showErrorNotification(getI18n().t('request-password-reset.error.cannot-send')));
    }
};

const requestPasswordResetToken = (userId, userEmail, totpToken) => (dispatch) => axios
    .post(Constants.LOST_PASSWORD_PATH, { userId, userEmail, totpToken })
    .then(onSuccess(dispatch))
    .catch(onError(dispatch));

export default requestPasswordResetToken;
